<template>
  <a-card>
    <div id="components-form-demo-advanced-search">

      <a-form class="ant-advanced-search-form" :form="form" @submit="handleSearch">
        <a-row>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.outboundView.title.outboundOrderNo')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-input placeholder="..." v-model="outboundFrom.outboundOrderNo"/>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.inboundView.title.shopName')"
              :labelCol="{span: 8}"
            >
              <a-select placeholder="..."
                        v-decorator="['note1', { rules: [{ required: true, message: 'Please select your shop!' }] }]"
                        v-model="outboundFrom.shopId" :options="shopNames">
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.outboundView.title.warehouseList')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-select placeholder="..." v-model="outboundFrom.warehouseId" :options="warehouseOptions">
              </a-select>
            </a-form-item>
          </a-col>

        </a-row>

        <a-row>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.outboundView.title.createTime')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-range-picker :value="createTimeRangeArray" @change="timeOnChange"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.outboundView.title.orderStatus')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-select placeholder="..." v-model="outboundFrom.orderStatusId" :options="outboundOrderStatusList">
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
              :label="$t('message.outboundView.title.platform')"
              :labelCol="{span: 5}"
              :wrapperCol="{span: 18, offset: 1}"
            >
              <a-select placeholder="..." v-model="outboundFrom.platformId">
                <a-select-option value="1">Ae Global</a-select-option>
                <a-select-option value="2">Lazada</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row>
        <span style="float: right; margin-top: 2px;">
          <a-button @click="handleSearch" type="primary">{{$t('message.outboundView.button.search')}}</a-button>
          <a-button @click="resetBtnClick"
                    style="margin-left: 8px">{{$t('message.outboundView.button.reset')}}</a-button>
        </span>
        </a-row>

      </a-form>

      <a-space class="operator">
        <a-dropdown>
          <a-menu @click="handleExportClick" slot="overlay">
            <a-menu-item key="exportAllOrder">{{$t('message.outboundView.button.exportAllOrder')}}</a-menu-item>
            <a-menu-item key="exportSelectedOrder">{{$t('message.outboundView.button.exportSelectedOrder')}}
            </a-menu-item>
          </a-menu>
          <a-button>
            {{$t('message.outboundView.button.exportBtn')}}
            <a-icon type="down"/>
          </a-button>
        </a-dropdown>
        <a-button @click="createNewOutBoundOrderClick">
          {{$t('message.inboundView.button.createOutboundBtn')}}
        </a-button>
      </a-space>

      <a-table :columns="columns" :rowKey="rowKey" :dataSource="dataSource" :scroll="{ x: 2500, y: 800 }"
               :pagination="pagination" :loading="loading" @change="getTableData"
               :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <span slot="purchaseOrderNo" slot-scope="text,record">
        <p><a slot="action" href="javascript:;" @click="showOrderDetail(record)">{{text}}</a></p>
        </span>

        <span slot="supplier" slot-scope="text,record">
        <p>{{$t('message.outboundView.table.merchantName')}}:{{ record.supplierName }}</p>
        <p>{{$t('message.outboundView.table.merchantCode')}}:{{ record.supplierCode }}</p>
      </span>
        <span slot="skuRender" slot-scope="text,record">
        <p>{{$t('message.outboundView.table.skuQuantity')}}:{{ record.skusQuantity }}</p>
        <p>{{$t('message.outboundView.table.planQuantity')}}:{{ record.totalQuantity }}</p>
        <p>{{$t('message.outboundView.table.receivedQuantity')}}:{{ record.receiveSkuQuantity }}</p>
      </span>
        <template slot="action" slot-scope="text,record">
          <a slot="action" href="javascript:;" @click="showOrderDetail(record)">{{$t('message.outboundView.table.detail')}}</a>
          <template v-if="record.platformCode==2">
            <template v-if="record.orderStatusCode <=30">
              <template v-if="record.orderStatusCode >=0">
                <a-divider type="vertical"/>
                <a slot="action" href="javascript:;" @click="cancelLzdPurchaseOrder(record)">{{$t('message.inboundView.table.cancel')}}
                </a>
              </template>
            </template>
          </template>

        </template>

      </a-table>

    </div>
    <!--   导出提示框-->
    <div>
      <export-alert ref="exportAlert"></export-alert>
    </div>

    <!--取消模态框-->
    <div>
      <template>
        <div>
          <a-modal v-model="visible"
                   :title="$t('message.inboundView.alert.prompt')"
                   :cancelText="$t('message.inboundView.alert.cancel')"
                   :okText="$t('message.inboundView.alert.sure')"
                   @ok="handleCancelOk">
            {{$t('message.inboundView.alert.title')}}
          </a-modal>
        </div>
      </template>
    </div>

  </a-card>
</template>
<script>
import {OutboundApi} from '../../js/OnboundApi'
import request from '../../utils/request'
import {InboundApi} from '../../js/InboundApi'

export default {
  computed: {
    columns () {
      return [
        {
          title: this.$t('message.outboundView.table.outboundOrder'),
          width: 250,
          fixed: 'left',
          scopedSlots: {customRender: 'purchaseOrderNo'},
          dataIndex: 'purchaseOrderNo'
        },
        {
          title: this.$t('message.outboundView.table.supplier'),
          width: 200,
          dataIndex: 'supplierName',
          scopedSlots: {customRender: 'supplier'}

        },
        {
          title: this.$t('message.outboundView.table.warehouse'),
          width: 200,
          dataIndex: 'warehouse'
        },
        {
          title: this.$t('message.outboundView.table.orderQuantity'),
          width: 200,
          dataIndex: 'skuDetails',
          scopedSlots: {customRender: 'skuRender'}
        },
        {
          title: this.$t('message.outboundView.table.creator'),
          width: 150,
          dataIndex: 'creator'
        },
        {
          title: this.$t('message.outboundView.table.createTime'),
          width: 150,
          dataIndex: 'createTime'
        },
        {
          title: this.$t('message.outboundView.table.orderStatus'),
          width: 150,
          dataIndex: 'orderStatus'
        },
        {
          title: this.$t('message.outboundView.table.outboundReason'),
          width: 150,
          dataIndex: 'outboundReason'
        },
        {
          title: this.$t('message.outboundView.table.inventoryType'),
          width: 150,
          dataIndex: 'inventoryType'
        },
        {
          title: this.$t('message.outboundView.table.platform'),
          width: 150,
          dataIndex: 'platform'
        },
        {
          title: this.$t('message.outboundView.table.outboundTime'),
          width: 150,
          dataIndex: 'outboundTime'
        },
        {
          title: this.$t('message.outboundView.table.operate'),
          width: 150,
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ]
    }
  },
  data () {
    return {
      visible: false,
      tempData: {
        cancelInboundOrderCode: '',
        cancelInboundUserId: ''
      },
      shopNames: [],
      form: this.$form.createForm(this, {name: 'outbound_search'}),
      outboundFrom: OutboundApi.outboundFromRequest,
      warehouseOptions: [],
      createTimeRangeArray: [],
      outboundOrderStatusList: [],
      outboundReasonList: [],
      pagination: {
        defaultPageSize: 10,
        current: 1,
        pageSize: 10,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.pagination.current = current
          console.log('change current=', this.pagination.current)
          this.getTableData()
        }
      },
      rowKey: 'id',
      loading: true,
      dataSource: this.dataSource,
      selectedRowKeys: [] // Check here to configure the default column
    }
  },
  created () {
    this.clearFromClick()
    // 初始化界面数据
    this.initOutboundData()
    this.getTableData()
  },
  methods: {
    createNewOutBoundOrderClick (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log(this.outboundFrom)
          this.$router.push({name: 'createNewOutboundOrder', query: {outboundDetailData: this.outboundFrom}})
        }
      })
    },
    cancelLzdPurchaseOrder (record) {
      this.tempData.cancelInboundOrderCode = record.purchaseOrderNo
      this.tempData.cancelInboundUserId = record.userId
      this.visible = true
    },
    handleCancelOk () {
      let cancelParam = {
        orderNumber: this.tempData.cancelInboundOrderCode,
        userId: this.tempData.cancelInboundUserId
      }
      console.log(InboundApi.InboundFromUrl.inboundOrderCancelUrl)
      console.log(InboundApi.InboundFromUrl.inboundOrderCancelUrl)
      request({
        method: 'post',
        url: InboundApi.InboundFromUrl.inboundOrderCancelUrl,
        data: cancelParam
      }).then(response => {
        console.log(response)
        if (response.data.success) {
          this.visible = false
          this.getTableData()
        } else {
          this.$message.error(response.data.errorMessage)
        }
      })
    },
    clearFromClick () {
      this.outboundFrom = {
        outboundOrderNo: '',
        lbxOrderCode: '',
        warehouseId: '',
        shopId: '',
        orderStatusId: '',
        platformId: '',
        cFromTime: '',
        cToTime: '',
        outboundReasonId: '',
        ids: '',
        pageSize: '',
        pageIndex: '',
        startTime: '',
        endTime: ''
      }
    },
    handleSearch (e) {
      this.pagination.defaultPageSize = 10
      this.pagination.pageSize = 10
      this.pagination.current = 1
      this.getTableData(this.inboundForm)
    },
    resetBtnClick () {
      this.clearFromClick()
      this.createTimeRangeArray = []
      this.getTableData()
    },
    timeOnChange (date, dateString) {
      this.createTimeRangeArray = date
      // 为变量赋值
      this.outboundFrom.cFromTime = dateString[0]
      this.outboundFrom.cToTime = dateString[1]
    },
    // 表格选择事件
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys)
      this.selectedRowKeys = selectedRowKeys
      if (selectedRowKeys !== undefined && selectedRowKeys.length > 0) {
        this.outboundFrom.ids = selectedRowKeys.join(',')
      }
    },
    showOrderDetail (record) {
      console.log(record)
      if (record.platform == 'AEG') {
        this.$router.push({name: 'aegOutboundDetail', query: {purchaseLineData: record}})
      } else {
        this.$router.push({name: 'LzdOutboundDetail', query: {purchaseLineData: record}})
      }
    },
    initOutboundData () {
      request({
        url: InboundApi.InboundFromUrl.queryShopNames,
        method: 'get'
      }).then(response => {
        this.shopNames = response.data.model.map(item => {
          return {label: item.name, value: item.sellerId}
        })
      })
      request({
        url: OutboundApi.OutboundFromUrl.queryWarehouseUrl,
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        method: 'get'
      }).then(response => {
        this.warehouseOptions = response.data.model.map(item => {
          return {label: item.name, value: item.storeCode}
        })
      })
      request({
        url: OutboundApi.OutboundFromUrl.queryOrderStatusUrl,
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        method: 'get'
      }).then(response => {
        console.log(response)
        this.outboundOrderStatusList = response.data.model.map(item => {
          return {label: item.name, value: item.value}
        })
      })

      request({
        url: OutboundApi.OutboundFromUrl.queryOutboundReasonsUrl,
        headers: {
          requestUserId: InboundApi.requestUserId
        },
        method: 'get'
      }).then(response => {
        this.outboundReasonList = response.data.model.map(item => {
          return {label: item.name, value: item.value}
        })
      })
    },
    getTableData () {
      this.outboundFrom.ids = ''
      this.outboundFrom.pageSize = this.pagination.pageSize
      this.outboundFrom.pageIndex = this.pagination.current
      this.loading = true
      this.outboundFrom.startTime = this.outboundFrom.cFromTime
      this.outboundFrom.endTime = this.outboundFrom.cToTime
      console.log(this.outboundFrom)
      let outboundOrderQueryVo = this.outboundFrom
      this.loading = true
      // ajax请求获取数据
      request({
        url: OutboundApi.OutboundFromUrl.queryOutboundOrderUrl,
        method: 'post',
        data: outboundOrderQueryVo
      }).then(response => {
        this.dataSource = response.data.model
        const pagination = {...this.pagination}
        pagination.total = response.data.totalCount
        this.pagination = pagination
        this.loading = false
      })
    },
    handleExportClick (e) {
      if (e.key == 'exportAllOrder') {
        this.outboundFrom.ids = ''
        this.$refs.exportAlert.exportFile(this.outboundFrom, 1002)
      } else if (e.key == 'exportSelectedOrder') {
        console.log(this.outboundFrom)
        console.log(this.outboundFrom.ids)
        this.$refs.exportAlert.exportFile(this.outboundFrom, 1002)
      }
    }
  }

}
</script>

<style>

  .ant-advanced-search-form .ant-form-item {
    display: flex;
  }

  .ant-advanced-search-form .ant-form-item-control-wrapper {
    flex: 1;
  }

  #components-form-demo-advanced-search .ant-form {
    max-width: none;
  }

  #components-form-demo-advanced-search .search-result-list {
    margin-top: 16px;
    border: 1px dashed #e9e9e9;
    border-radius: 6px;
    background-color: #fafafa;
    min-height: 200px;
    text-align: center;
    padding-top: 80px;
  }

  .notshow {
    display: none;
  }

  .editable-row-operations a {
    margin-right: 8px;
  }

</style>



// WEBPACK FOOTER //
// src/views/icp/Outbound.vue